import React from "react"

const ControlVideoProgressBar = ({
  className,
  loadProgressValue,
  playProgressValue,
  handleSeekMouseDown,
  handleSeekChange,
  handleSeekMouseUp,
}) => {
  return (
    <div className={`${className} h-1 relative w-full bg-gray-900-70o group`}>
      <progress
        className={`h-1 appearance-none absolute inset-0 w-full bg-transparent block [&::-webkit-progress-bar]:h-1 [&::-webkit-progress-value]:h-1  [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-gray-500 [&::-moz-progress-bar]:bg-gray-500`}
        max="1"
        value={loadProgressValue}
      ></progress>
      <progress
        className={`h-1 appearance-none absolute inset-0 w-full bg-transparent block [&::-webkit-progress-bar]:h-1 [&::-webkit-progress-value]:h-1  [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-primary-400 [&::-moz-progress-bar]:bg-primary-400`}
        max="1"
        value={playProgressValue}
      ></progress>
      <input
        className="w-full top-0 h-2 mb-4 absolute cursor-pointer appearance-none bg-transparent [&::-webkit-slider-thumb]:transition-colors [&::-webkit-slider-thumb]:duration-300 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:bg-transparent group-hover:[&::-webkit-slider-thumb]:bg-transparent [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:-mt-1 [&::-webkit-slider-thumb]:-ml-1 [&::-moz-range-progress]:appearance-none [&::-moz-range-progress]:invisible [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:bg-transparent [&::-moz-range-thumb]:border-none [&::-moz-range-thumb]:w-3 [&::-moz-range-thumb]:h-3"
        type="range"
        min={0}
        max={0.999999}
        step="any"
        value={playProgressValue}
        onMouseDown={handleSeekMouseDown}
        onChange={(e) => handleSeekChange(e)}
        onMouseUp={(e) => handleSeekMouseUp(e)}
      />
    </div>
  )
}

export default ControlVideoProgressBar
